import Button from '../core/Button';

const downloadImage = (url) => {
  const link = document.createElement('a');
  link.download = 'tour-profile-image.png';
  link.href = url;
  link.click();
};

const DownloadButton = ({ imageUrl }) => (
  <Button onClick={() => downloadImage(imageUrl)}>Download</Button>
);

export default DownloadButton;
